// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { profileManager } from "../../game_theme/flow_fb/flowController";
import { PIXI } from "../engine/tbPIXI";
import { ComponentLabel } from "../framework/components/ComponentLabel";
import { ComponentPicture } from "../framework/components/ComponentPicture";
import { tgfHooks } from "../framework/hooks/hooks";
import { tgfDictionary } from "../framework/tgfDictionary";
import { tgfGraphics } from "../framework/tgfGraphics";
import { Custom_share_01, Custom_share_02, Custom_update_01, s_button_notification, Custom_update_02, Custom_update_03, gamebot_match_notification_01, custom_update_06 } from "./AssetDefinitions/ImageDefinitions";
import { playController } from "./gameController";
export var NudgeFactory = function () {
    "use strict";
    this._defaultOutputSize = { x: 200, y: 200 };
};
NudgeFactory.GetPremadeNudge = function (name, bgIndex, data) {
    "use strict";
    switch (name) {
        case "share":
            var bg = null;
            switch (bgIndex) {
                case 0:
                case 1:
                default:
                    bg = Custom_share_01;
                    break;
                case 2:
                    bg = Custom_share_02;
                    break;
            }
            if (data.canAddScore) {
                return NudgeFactory.CreateNudge(bg, [
                    new ComponentPicture({
                        image: profileManager.getInfo(data.winData["id"]).image,
                        width: 135,
                        height: 135,
                        x: 255 + 67.5,
                        y: 20 + 67.5
                    }),
                    new ComponentLabel({
                        text: '+' + (data.winData["totalPigs"].toString()),
                        xScale: 1,
                        yScale: 1,
                        font: {
                            fontFamily: 'angrybirds_regular',
                            fontSize: 36,
                            fillColor: "#181818",
                            align: "center",
                            baseline: "middle"
                        },
                        x: 319,
                        y: 242
                    })
                ]);
            }
            else {
                return NudgeFactory.CreateNudge(bg, [
                    new ComponentPicture({
                        image: profileManager.getInfo(data.winData["id"]).image,
                        width: 135,
                        height: 135,
                        x: 255 + 67.5,
                        y: 20 + 67.5
                    })
                ]);
            }
        case "update":
            if (bgIndex === 1) {
                return NudgeFactory.CreateNudge(Custom_update_01, [
                    new ComponentPicture({
                        image: playController.opponentData.image,
                        width: 140,
                        height: 140,
                        x: 46 + 70,
                        y: 156 + 70
                    }),
                    new ComponentPicture({
                        image: s_button_notification,
                        width: s_button_notification.width,
                        height: s_button_notification.height,
                        x: 45 - (s_button_notification.width / 2),
                        y: 155 - (s_button_notification.height / 2)
                    })
                ]);
            }
            else if (bgIndex === 2) {
                return NudgeFactory.CreateNudge(Custom_update_02, [
                    new ComponentPicture({
                        image: profileManager.getInfo(tgfHooks.getPlayerID()).image,
                        width: 159,
                        height: 159,
                        x: 245 + (159 / 2),
                        y: 81 + (159 / 2)
                    }),
                    new ComponentPicture({
                        image: s_button_notification,
                        width: s_button_notification.width,
                        height: s_button_notification.height,
                        x: 240 - (s_button_notification.width / 2),
                        y: 76 - (s_button_notification.width / 2)
                    })
                ]);
            }
            else if (bgIndex === 3) {
                return NudgeFactory.CreateNudge(Custom_update_03, [
                    new ComponentPicture({
                        image: profileManager.getInfo(tgfHooks.getPlayerID()).image,
                        width: 136,
                        height: 136,
                        x: 77 + 68,
                        y: 92 + 68
                    }),
                    new ComponentPicture({
                        image: s_button_notification,
                        width: s_button_notification.width,
                        height: s_button_notification.height,
                        x: 71 - (s_button_notification.width / 2),
                        y: 89 - (s_button_notification.height / 2)
                    })
                ]);
            }
        case "matchNotification":
            var componentList = [];
            componentList.push(new ComponentPicture({
                image: profileManager.getInfo(tgfHooks.getPlayerID()).image,
                width: 134,
                height: 134,
                x: 310,
                y: 155,
                angle: -0.18
            }));
            if (data.birdCard) {
                componentList.push(new ComponentPicture({
                    image: data.birdCard,
                    width: 140,
                    height: 203,
                    x: 500,
                    y: 220
                }));
            }
            return NudgeFactory.CreateNudge(gamebot_match_notification_01, componentList);
        case "suggestedFriends":
            var componentList = [];
            componentList.push(new ComponentPicture({
                image: profileManager.getInfo(tgfHooks.getPlayerID()).image,
                width: 134,
                height: 134,
                x: 310,
                y: 155,
                angle: -0.18
            }));
            return NudgeFactory.CreateNudge(custom_update_06, componentList);
    }
};
/*
    Takes the provided bgImg and elements, and exports a base64string of the image
    Params:
        bgImg       -       The background image of the nudge. Should be a ComponentPicture.
        elements    -       Array of elements to add to image; Label or Pictures

    Example usage:
        var base64string = NudgeFactory.CreateNudge( Custom_update_01,
            [
                new ComponentPicture({
                    image: playController.opponentData.image, // PLACEHOLDERS HAVE A TOP-LEFT PIVOT, BUT FB IMAGES HAVE A CENTER PIVOT
                    width:95,
                    height:95,
                    x:76 + (95/2),
                    y:149+ (95/2)
                }),
                new ComponentPicture({
                    image: profileManager.getInfo(tgfHooks.getPlayerID()).image,
                    width:125,
                    height:125,
                    x:464 + (125/2),
                    y:45 + (125/2)
                }),
                new ComponentLabel({
                    text: "YOUR TURN!",
                    font: {fontFamily : 'angrybirds_regular', fontSize: 36, fill : '0xfefefe', align : 'right', stroke: 'black', strokeThickness: 3},
                    x:610,
                    y:250
                })
            ]
        ); */
NudgeFactory.CreateNudge = function (bgImg, elements) {
    "use strict";
    var renderTexture = null;
    var container = new PIXI["Container"]();
    if (bgImg) {
        renderTexture = PIXI["RenderTexture"]["create"](bgImg.width, bgImg.height);
        bgImg.sprite["setTransform"]();
        container["addChild"](bgImg.sprite);
    }
    else {
        renderTexture = PIXI["RenderTexture"]["create"](this._defaultOutputSize.x, this._defaultOutputSize.y);
    }
    for (var index = 0; index < elements.length; index++) {
        var element = elements[index];
        switch (element.name) {
            case "Picture":
                element.image = element.image.clone();
                element.image.sprite["position"]["set"](element.x, element.y);
                element.image.sprite = this._SmartScale(element.image.sprite, { x: element.width, y: element.height });
                if (element.angle) {
                    element.image.sprite["rotation"] = (element.angle);
                }
                container["addChild"](element.image.sprite);
                break;
            case "Label":
                if (!element.font.fill && element.font.fillColor)
                    element.font.fill = element.font.fillColor;
                if (element.font.fill && typeof (element.font.fill) !== 'string')
                    console.log("Fill is not a string!");
                if (typeof (element.font.stroke) !== 'number' && element.font.strokeColor)
                    element.font.stroke = element.font.strokeColor;
                if (element.font.stroke && typeof (element.font.stroke) !== 'string')
                    console.log("Stroke color is not a string!");
                var tempTxt = new PIXI["Text"](element.text, element.font);
                var oldWidth = 0;
                if (element.width && element.width < tempTxt["width"]) {
                    oldWidth = tempTxt["width"];
                    tempTxt["width"] = element.width;
                }
                if (element.height && element.height < tempTxt["height"]) {
                    tempTxt["height"] = element.height;
                }
                else if (!element.height && oldWidth !== 0) {
                    tempTxt["height"] = (tempTxt["width"] / oldWidth) * tempTxt["height"];
                }
                var storedScales = {
                    x: tempTxt["scale"]["x"],
                    y: tempTxt["scale"]["y"]
                };
                switch (element.font.align) {
                    case 'center':
                        tempTxt["setTransform"](element.x - (tempTxt.width * 0.5), element.y, storedScales.x, storedScales.y);
                        break;
                    case 'right':
                        tempTxt["setTransform"](element.x - tempTxt.width, element.y, storedScales.x, storedScales.y);
                        break;
                    default:
                        tempTxt["setTransform"](element.x, element.y, storedScales.x, storedScales.y);
                        break;
                }
                if (element.angle) {
                    tempTxt["rotation"] = (element.angle);
                }
                container["addChild"](tempTxt);
                break;
            default:
                break;
        }
    }
    tgfGraphics.renderer["render"](container, renderTexture);
    var result = (tgfGraphics.renderer["extract"]["canvas"](renderTexture))["toDataURL"]("image/jpeg");
    renderTexture["destroy"](true);
    return result;
};
NudgeFactory._createLocalizationTemplate = function () {
    return {
        'default': null,
        'localizations': {
            'en_US': 'en_US',
            'ca_ES': 'es_ES',
            'cy_GB': 'en_US',
            'de_DE': 'de_DE',
            'eu_ES': 'es_ES',
            'en_UD': 'en_US',
            'es_LA': 'es_ES',
            'es_ES': 'es_ES',
            'fr_FR': 'fr_FR',
            'gl_ES': 'es_ES',
            'nl_NL': 'nl_NL',
            'fy_NL': 'nl_NL',
            'pl_PL': 'pl_PL',
            'pt_BR': 'pt_BR',
            'pt_PT': 'pt_BR',
            'tr_TR': 'tr_TR',
            'ku_TR': 'tr_TR',
            'nl_BE': 'nl_NL',
            'en_GB': 'en_US',
            'fr_CA': 'fr_FR',
            'br_FR': 'fr_FR',
            'co_FR': 'fr_FR',
            'sz_PL': 'pl_PL'
        }
    };
};
NudgeFactory.GenerateCustomUpdateLocalization = function (messageKey, args) {
    var defaultStrArr = [tgfDictionary.getText(messageKey, tgfDictionary.getText(messageKey), 'en-us')].concat(args);
    var result = NudgeFactory._createLocalizationTemplate();
    result['default'] = String.format.apply(this, defaultStrArr);
    var availableLanguages = tgfDictionary.getAvailableLanguages();
    for (var key in availableLanguages) {
        var formattedKey = availableLanguages[key];
        formattedKey = formattedKey.replace(formattedKey.substring(formattedKey.indexOf('-')), formattedKey.substring(formattedKey.indexOf('-')).toUpperCase());
        formattedKey = formattedKey.replace('-', '_');
        var tempArgs = [
            tgfDictionary.getText(messageKey, tgfDictionary.getText(messageKey), availableLanguages[key])
        ].concat(args);
        var string = String.format.apply(this, tempArgs);
        result['localizations'][formattedKey] = string;
        for (var lKey in result['localizations']) {
            if (result['localizations'][lKey] === formattedKey) {
                result['localizations'][lKey] = string;
            }
        }
    }
    return result;
};
/*
    Figures out the amount to rescale an image using .setScale() given dimensions
    size = { x: 0, y: 0 }
*/
NudgeFactory._SmartScale = function (image, size) {
    var imgSize = { x: image.width, y: image.height };
    // Don't want to divide by zero!
    if (imgSize.x !== 0 && imgSize.y !== 0) {
        var correctScale = { x: 0, y: 0 };
        correctScale.x = size.x / imgSize.x;
        correctScale.y = size.y / imgSize.y;
        if (image.scale) {
            image.scale.set(correctScale.x, correctScale.y);
        }
        else if (image.setScale) {
            image.setScale(correctScale.x, correctScale.y);
        }
        else if (image.xScale && image.yScale) {
            image.xScale = correctScale.x;
            image.yScale = correctScale.y;
        }
        else {
            console.log("Cannot resize!");
        }
    }
    else
        console.log("Cannot resize! Division by zero!");
    return image;
};
